// exports CoderQAGeneratorType - an immutable object 'enum'
// usage: import { CoderQAGeneratorType } from '../../enums/CoderQAGeneratorType';
const coderQAGeneratorTypes = {
    User_Generated: 1,
    System_Generated: 2
};
Object.freeze(coderQAGeneratorTypes);
export const CoderQAGeneratorType = coderQAGeneratorTypes;